import { Box, Container, Grid, Typography } from '@mui/material';
import registerIllustration from 'assets/images/registerIllustration.svg';
import Link from 'components/Link';
import podLogo from 'assets/images/pod-logo.svg';
import { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import { FirstStep } from 'components/v2/common/Signup/FirstStep';
import { EmailSignup } from 'components/v2/common/Signup/EmailSignup';
import { GmailSignup } from 'components/v2/common/Signup/GmailSignup';

export interface GoogleProfileObj {
  email: string;
  familyName: string;
  givenName: string;
  googleId: string;
  imageUrl: string;
  name: string;
}

export type EmailStepInputs = {
  referrer_code?: string;
  password: string;
  confirm_password?: string;
};

export type StepOneInputs = {
  first_name: string;
  last_name: string;
  email: string;
  phone_no: string;
};

export type GmailStepInputs = {
  referrer_code?: string;
  phone_no: string;
};

const RegisterTest = () => {
  const [signupType, setSignupType] = useState<null | 'gmail' | 'email'>(null);
  const [googleData, setGoogleData] = useState<null | GoogleProfileObj>(null);
  const [emailSignUpData, setEmailSignUpData] = useState<null | StepOneInputs>(
    null,
  );

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      flexGrow={1}
      bgcolor="#F3F9EC"
      // maxHeight="40vh"
    >
      <ToastContainer />
      <Container maxWidth="lg">
        <Grid container>
          <Grid
            item
            md={6.5}
            sx={{
              display: {
                xs: 'none',
                md: 'block',
              },
            }}
          >
            <Box
              sx={{
                '& img': {
                  maxWidth: '100%',
                  maxHeight: '100%',
                },
              }}
            >
              <img src={registerIllustration.src} alt="" />
            </Box>
          </Grid>
          <Grid item md={5.5} xs={12}>
            <Box
              sx={{
                pl: {
                  xs: 'inherit',
                  md: '110px',
                },
              }}
            >
              <Box
                display="flex"
                sx={{
                  '& a': {
                    mr: 2,
                  },
                }}
              >
                <Link href="/faqs" noLinkStyle>
                  <Typography>FAQs</Typography>
                </Link>
                <Link href="/pod-cafe" noLinkStyle>
                  <Typography>POD Cafe</Typography>
                </Link>
                <Link href="/about" noLinkStyle>
                  <Typography>About</Typography>
                </Link>
              </Box>
              <Box mt={7}>
                <img src={podLogo.src} alt="pod logo" />
              </Box>
              {!signupType ? (
                <FirstStep
                  setSignupType={setSignupType}
                  setGoogleData={setGoogleData}
                  setEmailSignUpData={setEmailSignUpData}
                />
              ) : signupType == 'email' ? (
                <EmailSignup emailSignUpData={emailSignUpData!} />
              ) : (
                <GmailSignup googleData={googleData!} />
              )}
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default RegisterTest;
